import * as React from 'react';
import { StrictMode } from 'react';
import { ErrorLogComponent } from '@cian/error-log-component';
import { Microfrontend, Provider as MicrofrontendProvider } from '@cian/mf-react';
import { IRegistry } from '@cian/mf-registry/browser';

import { IAppInitialContext } from '../../../AppModulesWrapper';
import { IWidgetManifest } from '../../../ServicePickerWidget/types/widgetManifest';

import { getMicrofrontendDemoPageAPI } from './utils';

export interface IMicrofrontendDemoPageParams {
  context: IAppInitialContext;
  parameters: {
    id: number | null;
    draftGuid: string | null;
    hostName: string | null;
  };
}

if (process.env.IS_BROWSER_BUILD) {
  window.appInterfaceV2 = window.appInterfaceV2 || {};
}

export const MicrofrontendDemoPage = ({ context, parameters }: IMicrofrontendDemoPageParams) => {
  const { logger, microfrontendsRegistry, config } = context;

  const manifest = config.getStrict<IWidgetManifest>('servicePickerWidgetManifest');

  React.useEffect(() => {
    const api = getMicrofrontendDemoPageAPI({ logger, microfrontendsRegistry: microfrontendsRegistry as IRegistry });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).microfrontendDemoPageAPI = api;
  }, [logger, microfrontendsRegistry]);

  return (
    <StrictMode>
      <ErrorLogComponent logger={logger}>
        <MicrofrontendProvider registry={microfrontendsRegistry}>
          <Microfrontend {...manifest} parameters={parameters} />
        </MicrofrontendProvider>
      </ErrorLogComponent>
    </StrictMode>
  );
};
